import React from "react";
import CryptoJS from "crypto-js";
import $ from "jquery";
import { connect } from "react-redux";
import "assets/scss/responsive.css";
import "./customstyle.css";
import Result from "./CSegmentQueryBuilder/Result";
import GroupModal from "./CSegmentQueryBuilder/Modal";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import PieChart from "./PieChart";
class CustSegment extends React.Component {
  constructor(props) {
    super(props);
    this.handler();
    this.state = {
      localStorageClientId: "",
      summaryBoxHeaderText: "Summary",
    };
  }
  handler = () => {};
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  componentDidMount() {
    let v3ClientIdArray = [
      "8c001fde-3728-48dc-9950-b8480ca9fbee", // Baja Fresh
      "1857ba2f-010f-4f49-bcd1-f9fd09db2799", // Primanti Bro's
      "30b8b18b-4a66-4f1a-9ee6-a60bb0da062f", // Bad Daddy's
      "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534", // Lou Malnatis
      "687c8c2a-0986-4147-bf38-0d5bac9f7530", // Eegee's
      "b44cc84d-73b5-4457-bb48-68e9626d08e1", // Viva Chicken
      "ca2d8a6b-0eb8-48e2-b81a-41d12c14e04c", // Brusters
      "712cc8e9-3a79-4900-b122-ec9812e0f0ca", // Fridays
      "3fe7e557-16f5-406c-bbc8-887fdec7ba8b", // ColdStoneCreamery
      "2bdbd6af-6cd3-4358-a1a0-437226a20ee9", // Goodwill
      "535a90f3-b463-4d5a-9a83-39c522589a6c", // Mambo
      "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406", // Houlihan's NE
      "7abec586-17b8-4174-993d-e3d86648ed60", // Houlihan's CEN
      "2b7ed789-e2d0-45c0-a45f-49e27d736a7b", // JGilberts
      "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9", // Seafood Grill
      "d1522630-2b9d-424e-a399-7ab3f7be274f", // Lennys
      "7203dd51-f88b-4a4b-877c-92326d027915", // Planet Smoothie
      "cf6144d2-bb68-43b6-9876-dbf620b57c21", // Sweet Frog
      "83da098f-2fc7-4b98-8455-c08f9aceb4ed", // Taco Time
      "37f97bea-f005-4be1-8e41-286ad79a7f3a", // Bahamabucks
      "ec5a162e-5e87-4819-93bd-70bbf3b5f096", // Brio Bravo
      "24ab940a-50d2-41fd-b3b2-c67ca6cb0304", // New Demo Client
      "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac", // Bertucci
      "874b6c6a-83ff-480b-b615-1972538813ba", // Bravo
      "b76e7818-deb1-4526-93a7-b398df3ea357", // Goodtimes
      "e08840c5-c7d0-48c7-9c24-124b4cd80735", // Ruby Tuesdays
      "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e", // Firebirds
      "0bc2a383-9ae0-4e9e-9652-0fb762ba6119", // Wow Car Wash
      "7bf99619-30a3-47a3-b1de-d72b4f7f99a7", // Better Buzz
      "a4dda78e-7678-4aaf-9bef-60a229085fc8", // Smoothie King
    ];

    this.setState(
      {
        localStorageClientId: JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("clientId"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ),
      },
      () => {
        if (v3ClientIdArray.includes(this.state.localStorageClientId)) {
          this.setState({
            summaryBoxHeaderText: "Post-Suppression Summary",
          });
        } else {
          this.setState({
            summaryBoxHeaderText: "Summary",
          });
        }
      }
    );
  }
  render() {
    let partial = "";
    this.props.dispatch({
      type: "CUST_REMOVE_SEGMENT_NAME",
    });
    let segmentNameTemp = this.props.cust_segmentName;
    let segmentDataTemp = this.props.cust_segmentData;
    let showSpinnerChart = "";
    let chartView = "";
    let displaySpinner = "";
    if (this.props.cust_showQuerySpinnerSegment === "yes") {
      displaySpinner = "show";
      showSpinnerChart = (
        <i className="fa fa-spinner fa-spin" style={{ fontSize: "24px" }} />
      );
    } else {
      /*else if (segmentNameTemp.length > 0 && ((this.props.cust_queryCount["query_count"] == "" || this.props.cust_queryCount["query_count"] == " ") || this.props.cust_queryCountTempSegment["query_count"] == "" || this.props.cust_queryCountTempSegment["query_count"] == " ")) {
      displaySpinner = 'show';
      showSpinnerChart = (
        <i className="fa fa-spinner fa-spin" style={{ fontSize: "24px" }} />
      );
    } */
      if (segmentNameTemp.length > 0) {
        showSpinnerChart = this.numberWithCommas(
          this.props.cust_queryCount["query_count"]
        );
        displaySpinner = "hide";
        /*let queryCount = 0;
        if (this.props.cust_queryCount["query_count"] != "" && this.props.cust_queryCount["query_count"] != " ") {
          queryCount = this.props.cust_queryCount["query_count"]
        } else {
          queryCount = this.props.cust_queryCountTempSegment["query_count"]
        }*/
        chartView = (
          <PieChart
            segmentsName={segmentNameTemp}
            segmentsData={segmentDataTemp} /*filteredAudience={queryCount}*/
          />
        );
      }
    }

    return (
      <GridContainer style={{ marginBottom: "0px" }}>
        <GridItem xs={8} sm={8} md={8}>
          <Card
            style={{
              textAlign: "left",
              marginBottom: "0px",
            }}
          >
            <div className="filtercentercontent summarycontent">
              <div
                className="filteraudiencetitle summarytitle"
                style={{ minHeight: "40px" }}
              >
                <h2 className="capitalize">Segment Criteria</h2>
                <a href="javascript:void(0)" style={{ float: "right" }}>
                  <GroupModal
                    buttonLabel="Add Filter"
                    selectedIndex="no_index"
                    selectedRule=""
                    mode="Create"
                    type="group"
                    buttonType="add group"
                    class="withoutbgbtn"
                    style={{ marginRight: "0px" }}
                  />
                </a>
              </div>
              <CardBody
                style={{
                  textAlign: "left",
                  // overflowY: "auto",
                  minHeight: "370px",
                  marginBottom: "0px",
                }}
              >
                <div className="filtercentercontent">
                  <div className="">
                    {/* <div class="btngroup">
                    <a href="javascript:void(0)" class="btn">
                      <i class="plussign" />
                      add group
                    </a>
                  </div> */}
                    <Result onButton="" />
                  </div>
                </div>
              </CardBody>
            </div>
          </Card>
        </GridItem>
        <GridItem xs={4} sm={4} md={4}>
          <Card
            style={{
              marginBottom: "0px",
            }}
          >
            <div className="filtercentercontent summarycontent">
              <div
                className="filteraudiencetitle summarytitle"
                style={{ minHeight: "40px" }}
              >
                <h2 className="capitalize">
                  {JSON.parse(
                    CryptoJS.AES.decrypt(
                      localStorage.getItem("activeChannel"),
                      process.env.REACT_APP_PASS
                    ).toString(CryptoJS.enc.Utf8)
                  ) !== "d977fc2b-2352-473b-9a54-b80765f0400c" &&
                  JSON.parse(
                    CryptoJS.AES.decrypt(
                      localStorage.getItem("activeChannel"),
                      process.env.REACT_APP_PASS
                    ).toString(CryptoJS.enc.Utf8)
                  ) !== "79b91604-9f03-428a-9026-9be77ca9a687"
                    ? this.state.summaryBoxHeaderText
                    : "Summary"}
                </h2>
              </div>
              <CardBody
                style={{
                  height: "370px",
                  textAlign: "center",
                  marginBottom: "0px",
                }}
              >
                {displaySpinner === "show"
                  ? showSpinnerChart
                  : displaySpinner === "hide"
                    ? chartView
                    : ""}
              </CardBody>
            </div>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}
const mapStateToProps = (state) => ({
  cust_count: state.cust_count,
  cust_tillSqlSelectionArr: state.cust_tillSqlSelectionArr,
  cust_afterSqlSelectionArr: state.cust_afterSqlSelectionArr,
  cust_ruleLeveltoggle: state.cust_ruleLeveltoggle,
  cust_groupLeveltoggle: state.cust_groupLeveltoggle,
  cust_title: state.title,
  cust_listDescription: state.listDescription,
  cust_queryCount: state.cust_queryCount,
  cust_showQuerySpinner: state.cust_showQuerySpinner,
  cust_showQuerySpinnerSegment: state.cust_showQuerySpinnerSegment,
  cust_segmentData: state.cust_segmentData,
  cust_segmentName: state.cust_segmentName,
  cust_queryCountTempSegment: state.cust_queryCountTempSegment,
});
export default connect(mapStateToProps)(CustSegment);



// WEBPACK FOOTER //
// ./src/views/Audiences/CustSegment.jsx